import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const isRemovalMethodSetting = (settingName: string) =>
  settingName.toLowerCase().includes('removal') ||
  settingName.toLowerCase().includes('deprovisioning');

/**
 * Returns a function that formats a setting's value for display. Removal
 * method values (e.g. "disable") are translated from
 * `applications:removalMethods.<value>`; unknown values fall back to the
 * capitalized label plus "account". Other settings return `label` unchanged.
 */
export const useFormatSettingValue = () => {
  const { t } = useTranslation('applications');

  return useCallback(
    (settingName: string, value: string, label: string = value): string => {
      if (!isRemovalMethodSetting(settingName)) return label;
      const capitalized =
        label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
      return t(`removalMethods.${value.toLowerCase()}`, {
        defaultValue: `${capitalized} account`,
      });
    },
    [t]
  );
};
